import { RedirectGuard } from './shared/guards/RedirectGuard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PaginaNaoEncontradaComponent } from './core/pagina-nao-encontrada.component';

const routes: Routes = [

  {
    path: 'sip-documentos',
    canActivate: [RedirectGuard],
    component: RedirectGuard,
    data: {
      externalUrl: 'http://uberaba.mg.gov.br/sipweb/#/sip-documentos'
    }
  },
  {
    path: 'sip-processos',
    canActivate: [RedirectGuard],
    component: RedirectGuard,
    data: {
      externalUrl: 'http://uberaba.mg.gov.br/sipweb/#/sip-processos'
    }
  },
  /*
  {
    path: 'sip-pedidos', loadChildren: () =>
      import('./modules/sip-pedidos/sip-pedidos.module').then(m => m.SipPedidosModule)
  },
  {
    path: 'sip-processos', loadChildren: () =>
      import('./modules/sip-processos/sip-processos.module').then(m => m.SipProcessosModule)
  },
  */
  {
    path: 'modal-area', loadChildren: () =>
      import('./modules/modal-area/modal-area.module').then(m => m.ModalAreaModule)
  },
  {
    path: 'gerar-etiqueta', loadChildren: () =>
      import('./modules/etiqueta-gerar/etiqueta-gerar.module').then(m => m.EtiquetaGerarModule)
  },
  {
    path: 'etiqueta-verificar/:token', loadChildren: () =>
      import('./modules/etiqueta-verificar/etiqueta-verificar.module').then(m => m.EtiquetaVerificarModule)
  },
  {
    path: 'taxa-licenciamento', loadChildren: () =>
      import('./modules/taxa-licenciamento/taxa-licenciamento.module').then(m => m.TaxaLicenciamentoModule)
  },
  {
    path: 'tipos-licencas-obras', loadChildren: () =>
      import('./modules/tipos-licencas-obras/tipos-licencas-obras.module').then(m => m.TiposLicencasObrasModule)
  },
  {
    path: 'pessoas', loadChildren: () =>
      import('./modules/pessoas/pessoas.module').then(m => m.PessoasModule)
  },
  {
    path: 'home', loadChildren: () =>
      import('./modules/home/home.module').then(m => m.HomeModule)
  },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'pagina-nao-encontrada', component: PaginaNaoEncontradaComponent },
  { path: '**', redirectTo: 'pagina-nao-encontrada' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
